<template>
  <div class="invoiceManage-bd tb" v-if="tableVisible">
    <custom-tab v-model="tab" :list="tabList" @change="onChangeTab" style="margin-left: -16px; width: calc(100% + 32px)"></custom-tab>
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 待开票（0）-->
        <template v-if="tab === '0'">
          <el-form-item>
            <el-button v-if="funcView.invoice_manage_submit_audit" type="primary" icon="icon icon-shenpi" :disabled="!tableSelect.length" @click="onApplyDialog">
              &nbsp;{{ funcView.invoice_manage_submit_audit }}
            </el-button>
          </el-form-item>
          <!-- 暂时隐藏， 后面需求要改 -->
          <!-- <el-form-item>
            <el-button type="primary" icon="icon icon-instock" @click="onSelectWaitInvoice">&nbsp;{{ $t('p_invoiceManage_xzdkp') }}</el-button>
          </el-form-item> -->
          <el-form-item>
            <el-button v-if="funcView.invoice_manage_import_wait_invoice" type="primary" icon="icon icon-daoru" @click="importInvoice()">
              &nbsp;{{ funcView.invoice_manage_import_wait_invoice }}
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-if="funcView.invoice_manage_del" type="primary" icon="icon icon-shanchu" :disabled="!tableSelect.length" @click="deleteWaitInvoice()">
              &nbsp;{{ funcView.invoice_manage_del }}
            </el-button>
          </el-form-item>
        </template>
        <!-- 审批开票（1）-->
        <template v-if="(tab === '1' && approveState === '10') || tab === '6'">
          <el-form-item v-if="funcView.invoice_manage_sync_u8">
            <el-button type="primary" :disabled="!syncU8Enable" @click="onSyncU8()">{{ funcView.invoice_manage_sync_u8 }}</el-button>
          </el-form-item>
        </template>
        <template v-if="tab === '1' && (approveState === '90' || approveState === '1' || approveState === '10')">
          <el-form-item>
            <el-button v-if="funcView.invoice_manage_cancel" type="primary" :disabled="!tableSelect.length" @click="onInvalidInvoiceBatch()">{{ funcView.invoice_manage_cancel }}</el-button>
          </el-form-item>
        </template>
        <!-- 配置项 -->
        <el-form-item style="float: right; margin-right: 0">
          <el-button class="table-set" style="vertical-align: top" @click.native="exportInvoiceTable()"><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-if="tab === '0'" v-model="formSearch.keyword" :placeholder="$t('fms_invoiceManage.htbhjsh')" @fetch="onPageChange({ page: 1 })"></search-input>
          <search-input v-else-if="tab === '1' || tab === '6'" v-model="formSearch.keyword" :placeholder="$t('fms_invoiceManage.fa_piao_liu_shui_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
          <search-input v-else v-model="formSearch.keyword" :placeholder="$t('fms_invoiceManage.fa_piao_bian_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link" ref="containerBtn"></switch-button>
        </el-form-item>
        <!-- 审批开票（1）-->
        <template v-if="tab === '1'">
          <el-form-item style="float: right">
            <el-radio-group v-model="approveState" @change="onPageChange({ page: 1 })">
              <el-radio-button label="10">{{ $t('fms_invoiceManage.shen_pi_tong_guo') }}</el-radio-button>
              <el-radio-button label="6">{{ $t('fms_invoiceManage.shen_pi_zhong') }}</el-radio-button>
              <el-radio-button label="90">{{ $t('fms_invoiceManage.shen_pi_ju_jue') }}</el-radio-button>
              <el-radio-button label="1">{{ $t('fms_invoiceManage.cao_gao') }}</el-radio-button>
              <el-radio-button label="100">{{ $t('fms_invoiceManage.yi_zuo_fei') }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </template>
      </el-form>
    </div>
    <!-- 更多搜索 -->
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item v-if="tab !== '10'" :label="$t('fms_invoiceManage.shen_qing_ri_qi')">
          <custom-date-picker v-model="formSearch.gmtCreate" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss" size="small"></custom-date-picker>
        </el-form-item>
        <el-form-item v-if="tab === '10'" :label="$t('fms_invoiceManage.kai_piao_ri_qi')">
          <custom-date-picker v-model="formSearch.invoiceTime" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss" size="small"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('fms_invoiceManage.gmfqymc')">
          <el-input v-model="formSearch.buyerName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_invoiceManage.shen_qing_ren')">
          <el-input v-model="formSearch.creator"></el-input>
        </el-form-item>
        <el-form-item :label="$t('fms_invoiceManage.fa_piao_lei_xing')">
          <invoice-type-select
            v-model="formSearch.invoiceTypeValue"
            ref="invoiceTypeSelect"
            @change="updateTypeAndClassByValue(formSearch, $event)"
            :clearable="true"
            :defaultValue="false"
          ></invoice-type-select>
        </el-form-item>
      </el-form>
    </switch-container>
    <!-- 待开票 -->
    <custom-table
      key="0"
      v-if="tab === '0'"
      v-loading="isLoading"
      :loading="isLoading"
      height="100%"
      :data="tableList"
      tableCode="invoiceMannage"
      type="checkbox"
      v-model="tableSelect"
      @sort="sortChange"
      @filter="filterChange"
      @column="getColumn"
      :slots="['termNum', 'invoiceAmount', 'invoiceType', 'action']"
    >
      <template slot="invoiceType" slot-scope="scope">{{ getItemNameByTypeAndClass(scope.row.invoiceType, scope.row.invoiceClass) }}</template>
      <template slot="termNum" slot-scope="scope">{{ scope.row.termNum || '-' }}/{{ scope.row.totalTerm || '-' }}</template>
      <template slot="invoiceAmount" slot-scope="scope">{{ scope.row.isRedInvoice ? '-' : '' }} {{ scope.row.paymentAmount - (scope.row.invoiceAmount || 0) }}</template>
      <template slot="action" slot-scope="scope">
        <span></span>
        <el-button v-if="funcView.invoice_manage_del" type="text" size="mini" @click="deleteWaitInvoice(scope.row)">{{ funcView.invoice_manage_del }}</el-button>
      </template>
    </custom-table>
    <!-- 审批开票 -->
    <custom-table
      key="1"
      v-if="tab === '1'"
      v-loading="isLoading"
      :loading="isLoading"
      height="100%"
      :data="tableList"
      tableCode="invoiceApplied"
      type="checkbox"
      v-model="tableSelect"
      @sort="sortChange"
      @filter="filterChange"
      @column="getColumn"
      :slots="['invoiceCode', 'invoiceAmount', 'invoiceType', 'action']"
      :filterArr="approveState === '100' ? [] : ['invoiceNum']"
    >
      <template slot="invoiceType" slot-scope="scope">{{ getItemNameByTypeAndClass(scope.row.invoiceType, scope.row.invoiceClass) }}</template>
      <template slot="invoiceCode" slot-scope="scope">
        <span class="cell-link" @click="onInvoiceDetails(scope.row.invoiceId, scope.row.isRedInvoice)">{{ scope.row.invoiceCode }}</span>
      </template>
      <template slot="invoiceAmount" slot-scope="scope">{{ scope.row.isRedInvoice ? '-' : '' }} {{ scope.row.invoiceAmount }}</template>
      <template slot="action" slot-scope="scope">
        <span></span>
        <el-button v-if="funcView.invoice_manage_register_invoice && approveState === '10'" type="text" size="mini" @click="onRegister(scope.row)">
          {{ funcView.invoice_manage_register_invoice }}
        </el-button>
        <el-button
          v-if="funcView.invoice_manage_cancel && (approveState === '90' || approveState === '1' || approveState === '10')"
          type="text"
          size="mini"
          @click="onInvalidInvoice(scope.row, approveState === '1')"
        >
          {{ funcView.invoice_manage_cancel }}
        </el-button>
        <el-button v-if="funcView.invoice_edit_remark" type="text" size="mini" @click="onEditRemarkInvoice(scope.row)">{{ $t('fms_invoiceManage.bian_ji_bei_zhu') }}</el-button>
      </template>
    </custom-table>
    <!-- 开票中 -->
    <custom-table
      key="2"
      v-if="tab === '6'"
      v-loading="isLoading"
      :loading="isLoading"
      height="100%"
      index
      :data="tableList"
      tableCode="invoiceIng"
      type="checkbox"
      v-model="tableSelect"
      @sort="sortChange"
      @filter="filterChange"
      @column="getColumn"
      :slots="['invoiceNum', 'invoiceAmount', 'invoiceType', 'invoiceCode', 'action']"
    >
      <template slot="invoiceType" slot-scope="scope">{{ getItemNameByTypeAndClass(scope.row.invoiceType, scope.row.invoiceClass) }}</template>
      <template slot="invoiceAmount" slot-scope="scope">{{ scope.row.isRedInvoice ? '-' : '' }} {{ scope.row.invoiceAmount }}</template>
      <template slot="invoiceCode" slot-scope="scope">
        <span class="cell-link" @click="onInvoiceDetails(scope.row.invoiceId)">{{ scope.row.invoiceCode || '-' }}</span>
      </template>
      <template slot="action" slot-scope="scope">
        <span></span>
        <el-button
          type="text"
          size="mini"
          @click="onGoRedDialog(scope.row)"
          v-if="
            funcView.invoice_manage_red_invoice &&
            scope.row.invoiceAmount > (scope.row.redInvoiceAmount || 0) + (scope.row.lockRedAmount || 0) &&
            isCrossMonth(scope.row.invoiceTime) &&
            !scope.row.isRedInvoice
          "
        >
          {{ funcView.invoice_manage_red_invoice }}
        </el-button>
        <el-button v-if="funcView.invoice_manage_cancel && !scope.row.isRedInvoice && isSameMonth(scope.row.invoiceTime)" type="text" size="mini" @click="onInvalidInvoice(scope.row)">
          {{ funcView.invoice_manage_cancel }}
        </el-button>
      </template>
    </custom-table>
    <!-- 已开票 -->
    <custom-table
      key="3"
      v-if="tab === '10'"
      v-loading="isLoading"
      :loading="isLoading"
      height="100%"
      index
      :data="tableList"
      tableCode="invoiceFinish"
      @sort="sortChange"
      @filter="filterChange"
      @column="getColumn"
      :slots="['invoiceNum', 'invoiceAmount', 'invoiceType', 'action']"
    >
      <template slot="invoiceType" slot-scope="scope">{{ getItemNameByTypeAndClass(scope.row.invoiceType, scope.row.invoiceClass) }}</template>
      <template slot="invoiceNum" slot-scope="scope">
        <template v-if="scope.row.isRedInvoice">
          <span class="cell-link" @click="onInvoiceDetails(scope.row.invoiceNum ? scope.row.invoiceId : '', scope.row.isRedInvoice)">{{ scope.row.invoiceNum || '-' }}</span>
          /
          <el-popover placement="bottom" trigger="hover" v-if="scope.row.oldInvoiceNum.split(',').length > 1">
            <span slot="reference" class="cell-link" @click="onInvoiceDetails(scope.row.oldInvoiceId.split(',')[0])">{{ scope.row.oldInvoiceNum.split(',')[0] }}...</span>
            <ul>
              <li v-for="(item, i) in scope.row.oldInvoiceNum.split(',')" :key="i" style="text-align: center">
                <span v-if="i > 0" @click="onInvoiceDetails(scope.row.oldInvoiceId.split(',')[i])" class="cell-link el-table--mini">{{ item }}</span>
              </li>
            </ul>
          </el-popover>
          <span v-else class="cell-link" @click="onInvoiceDetails(scope.row.oldInvoiceNum ? scope.row.oldInvoiceId : '')">{{ scope.row.oldInvoiceNum || '-' }}</span>
        </template>
        <template v-else>
          <span class="cell-link" @click="onInvoiceDetails(scope.row.invoiceNum ? scope.row.invoiceId : '', scope.row.isRedInvoice)">{{ scope.row.invoiceNum || '-' }}</span>
        </template>
      </template>
      <template slot="invoiceAmount" slot-scope="scope">{{ scope.row.isRedInvoice ? '-' : '' }} {{ scope.row.invoiceAmount }}</template>
      <template slot="action" slot-scope="scope">
        <span></span>
        <!-- 冲红 -->
        <!-- invoiceClass: 1纸质，2电子 -->
        <el-button
          type="text"
          size="mini"
          @click="onApplyGoRed(scope.row)"
          v-if="
            funcView.invoice_manage_red_invoice &&
            scope.row.invoiceAmount > (scope.row.redInvoiceAmount || 0) + (scope.row.lockRedAmount || 0) &&
            !scope.row.isRedInvoice &&
            ((`${scope.row.invoiceClass}` == '1' && isCrossMonth(scope.row.invoiceTime)) || `${scope.row.invoiceClass}` == '2')
          "
        >
          {{ funcView.invoice_manage_red_invoice }}
        </el-button>
        <!-- 作废 -->
        <el-button v-if="funcView.invoice_manage_cancel && isSameMonth(scope.row.invoiceTime) && `${scope.row.invoiceClass}` == '1'" type="text" size="mini" @click="onInvalidInvoice(scope.row)">
          {{ funcView.invoice_manage_cancel }}
        </el-button>
        <!-- 查看 -->
        <el-button v-if="scope.row.invoiceUrl && funcView.invoice_manage_detail" type="text" size="mini" @click="viewInvoiceUrl(scope.row)">{{ funcView.invoice_manage_detail }}</el-button>
        <!-- 邮件 -->
        <el-button v-if="funcView.invoice_manage_email && isShowEmail(scope.row)" type="text" size="mini" @click="showEmail(scope.row)">{{ funcView.invoice_manage_email }}</el-button>
      </template>
    </custom-table>
    <div class="table-page">
      <accounts-footer-sum v-if="tab != '10'" :data="tableSelect" :total="totalInvoice" :totalPaymentAmount="-1"></accounts-footer-sum>
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <!-- 申请开红票(月账单选择) -->
    <invoice-gored-select-dialog :model="dialogModel8" v-if="dialogVisible8" @close="dialogVisible8 = false" @success="onGoRedDialog"></invoice-gored-select-dialog>
    <!-- 财务申请审批 -->
    <approval-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="getTableList"></approval-dialog>
    <!-- 导入待开票 -->
    <invoice-import-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="getTableList"></invoice-import-dialog>
    <!-- 登记开票 -->
    <invoice-register-dialog v-if="dialogVisible3" :model="dialogModel3" @close="dialogVisible3 = false" @success="getTableList"></invoice-register-dialog>
    <!-- 发票详情 -->
    <invoice-details-dialog v-if="dialogVisible4" :model="dialogModel4" @close="dialogVisible4 = false"></invoice-details-dialog>
    <!-- 选择待开票 -->
    <invoice-wait-dialog v-if="dialogVisible5" :model="dialogModel5" @close="dialogVisible5 = false" @success="getTableList"></invoice-wait-dialog>
    <invoice-remark-dialog v-if="dialogVisible6" :model="dialogModel6" @close="dialogVisible6 = false" @success="getTableList"></invoice-remark-dialog>
    <!-- 发送邮件 -->
    <send-email-dialog v-if="emailVisible" :model="emailModel" @close="emailVisible = false" @success="getTableList"></send-email-dialog>
  </div>
</template>
<script>
import moment from 'moment';
import qs from 'qs';
import apis from '@/utils/apis';
import invoiceGoredSelectDialog from '@/pages/fms/components/invoice_gored_select_dialog.vue';
import approvalDialog from '@/components/approvalCenter/approval_dialog.vue';
import invoiceDetailsDialog from '@/pages/fms/components/invoice_details_dialog.vue';
import accountsFooterSum from '@/pages/fms/components/accounts_footer_sum.vue';
import sendEmailDialog from '@/pages/fms/components/send_email_dialog.vue';
import invoiceTypeMixins from '@/mixins/invoice_type_mixins.js';
import invoiceTypeSelect from '@/components/invoiceTypeSelect.vue';
import invoiceImportDialog from './children/invoice_import_dialog.vue';
import invoiceRegisterDialog from './children/invoice_register_dialog.vue';
import invoiceWaitDialog from './children/invoice_wait_dialog.vue';
import invoiceRemarkDialog from './children/invoice_remark_dialog.vue';

export default {
  name: 'invoiceManage',
  mixins: [invoiceTypeMixins],
  components: {
    approvalDialog,
    invoiceImportDialog,
    invoiceRegisterDialog,
    invoiceDetailsDialog,
    invoiceGoredSelectDialog,
    invoiceWaitDialog,
    invoiceRemarkDialog,
    accountsFooterSum,
    sendEmailDialog,
    invoiceTypeSelect,
  },
  data() {
    return {
      tableColumn: [],
      tab: '0',
      billType: undefined,
      approveState: '',
      isLoading: false,
      formSearch: {
        invoiceTypeValue: '',
        invoiceType: '',
        invoiceClass: '',
        creator: '',
        invoiceState: '',
        gmtCreate: [],
        invoiceTime: [],
        approveState: undefined,
        billType: undefined,
        keyword: '',
        buyerNumber: '',
        buyerName: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
      },
      tableSelect: [],
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      dialogVisible2: false,
      dialogModel2: {},
      dialogVisible3: false,
      dialogModel3: {},
      dialogVisible4: false,
      dialogModel4: {},
      link: null,
      dialogVisible5: false,
      dialogModel5: {},
      dialogVisible6: false,
      dialogModel6: {},
      dialogVisible8: false,
      dialogModel8: {},
      emailVisible: false,
      emailModel: {},
    };
  },
  computed: {
    // 判断是否能同步u8
    syncU8Enable() {
      const tableSelect = this.tableSelect || [];
      if (tableSelect.length) {
        // 销售类账单发票不支持同步U8进行开票
        return !tableSelect.some(item => [40, 41, 42].includes(item.billType));
      }
      return false;
    },
    tabList() {
      const ret = [];
      if (this.funcView.invoice_wait_apply_list) {
        ret.push({
          name: this.$t('fms_invoiceManage.dai_kai_piao'),
          value: '0',
        });
      }
      if (this.funcView.invoice_has_apply_list) {
        ret.push({
          name: this.$t('fms_invoiceManage.shen_pi_kai_piao'),
          value: '1',
        });
      }
      if (this.funcView.invoice_invoicing_list) {
        ret.push({
          name: this.$t('fms_invoiceManage.kai_piao_zhong'),
          value: '6',
        });
      }
      if (this.funcView.invoice_has_invoice_list) {
        ret.push({
          name: this.$t('fms_invoiceManage.yi_kai_piao'),
          value: '10',
        });
      }
      return ret;
    },
    tableVisible() {
      return this.funcView.invoice_wait_apply_list || this.funcView.invoice_has_apply_list || this.funcView.invoice_has_invoice_list;
    },
    totalInvoice() {
      return this.tableSelect.reduce((pre, item) => {
        if (this.tab === '0') {
          return item.paymentAmount - (item.invoiceAmount || 0) + pre;
        }
        if (this.tab === '1' || this.tab === '6') {
          return item.isRedInvoice ? pre - (item.invoiceAmount || 0) : (item.invoiceAmount || 0) + pre;
        }
        return 0;
      }, 0);
    },
  },
  watch: {
    tabList: {
      immediate: true,
      handler(val) {
        if (val && val.length) {
          const item = val[0];
          if (!this.tab) {
            this.tab = item.value;
          }
        }
      },
    },
  },
  mounted: function () {
    this.resetFormSearch = JSON.stringify(this.formSearch);

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });
    this.getTableList();
  },
  methods: {
    viewInvoiceUrl(row) {
      window.open(row.invoiceUrl);
    },
    // show Email 判断
    isShowEmail(row) {
      // 只有电子类型才能显示
      const invoiceClassMap = this.dicMap.invoice_class;
      return invoiceClassMap && `${invoiceClassMap.electronic}` === `${row.invoiceClass}`;
    },
    filterChange(value) {
      this.formSearch = Object.assign(this.formSearch, value);
      this.onPageChange({ page: 1 });
    },
    showEmail(row) {
      this.emailModel = {
        title: this.$t('fms_invoiceManage.fa_song_you_jian'),
        data: row,
      };
      this.emailVisible = true;
    },
    getColumn(table) {
      this.tableColumn = table.tableColumn;
      this.setColumn(table);
    },
    // 切换状态
    onChangeTab: function () {
      this.$refs.container.close();
      this.$refs.containerBtn.open = false;
      this.approveState = '';
      this.formSearch.approveState = undefined;
      this.formSearch.keyword = '';
      this.$nextTick(() => {
        this.tableSelect = [];
        this.onPageChange({ page: 1 });
      });
    },
    // 获取表格数据
    getTableList: function () {
      if (this.tab === '0') {
        this.getTableList1();
      } else {
        this.getTableList2();
      }
    },
    getTableList1: function () {
      this.formSearch.invoiceState = null;
      this.formSearch.billTradeState = null;
      this.formSearch.excludeGiveBill = true; // 待开票列表默认不展示赠品发票
      // this.billType = '10,12,13,15,20,40,41,42,100'; // 不存在则默认值
      this.formSearch.invoiceTime = [];
      // this.formSearch.billType = this.formSearch.billType && Object.keys(this.formSearch.billType).length ? this.formSearch.billType : this.billType.split(',');
      this.isLoading = true;
      const tab = this.tab;
      this.$getJSON(apis.invoiceWaitPage, this.formSearch).then((res) => {
        if (tab === this.tab) {
          this.isLoading = false;
          this.tableList = res.data.records;
          this.totalRows = res.data.total;
        }
      });
    },
    getTableList2: function () {
      if (this.tab === '1') {
        this.approveState = this.approveState || '10'; // 不存在则默认值
        this.formSearch.approveState = this.approveState;
      } else {
        // this.billType = '10,12,13,15,20,40,41,42,100'; // 不存在则默认值
        // this.formSearch.billType = this.formSearch.billType && Object.keys(this.formSearch.billType).length ? this.formSearch.billType : this.billType.split(',');
      }
      if (this.tab === '10') {
        this.formSearch.gmtCreate = [];
      } else {
        this.formSearch.invoiceTime = [];
      }
      if (this.tab === '1' && this.approveState === '100') {
        this.formSearch.invoiceState = '100';
      } else {
        this.formSearch.invoiceState = this.tab;
      }
      this.isLoading = true;
      const tab = this.tab;
      this.$getJSON(apis.invoiceAllPage, this.formSearch).then((res) => {
        if (tab === this.tab) {
          this.isLoading = false;
          this.tableList = res.data.records;
          this.totalRows = res.data.total;
        }
      });
    },
    // 同步状态
    onSyncU8: function () {
      const tips = this.$t('fms_invoiceManage.nqdytbxzdfpdU8m');
      this.$showConfirm(tips, null, {
        dangerouslyUseHTMLString: true,
      }).then(() => {
        const ids = this.tableSelect.map(i => i.invoiceId);
        this.$postJSON(apis.invoiceSync2U8, ids).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 清空
    clearFilter: function () {
      this.formSearch = JSON.parse(this.resetFormSearch);
      this.onPageChange({ page: 1 });
    },
    // 冲红按钮判断 是否当月之前
    isCrossMonth(invoiceTime) {
      return moment(invoiceTime).isBefore(moment(), 'month');
    },
    // 是否是当前月份
    isSameMonth(invoiceTime) {
      return moment(invoiceTime).isSame(moment(), 'month');
    },
    // 作废（已开票）
    onInvalidInvoice: function (row, isDraft) {
      this.$showConfirm(this.$t('fms_invoiceManage.nqdyzfgfpm'))
        .then(() => {
          if (isDraft) {
            // 草稿作废按审批那边处理
            this.$postJSON(`${apis.apsApproveApprovalCancel}/invoice/${row.changeId}`).then(() => {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success',
              });
              this.getTableList();
            });
            return;
          }
          this.$postJSON(`${apis.invoiceInvalid}/${row.invoiceId}`).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 作废批量（已开票）
    onInvalidInvoiceBatch: function () {
      const list = this.tableSelect.map(t => t.invoiceId);
      this.$showConfirm(this.$t('fms_invoiceManage.nqdyzfxzfpm'))
        .then(() => {
          this.$postJSON(apis.invoiceInvalidBatch, list).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 申请开红票,选择月账单
    onApplyGoRed(row) {
      this.dialogModel8 = {
        title: this.$t('fms_invoiceManage.xzyzd'),
        invoiceId: row.invoiceId,
      };
      this.dialogVisible8 = true;
    },
    // 发票申请（提交审批）
    onApplyDialog: function () {
      const tableSelect = this.tableSelect || [];
      const hasGiveBillList = tableSelect.filter(item => item.hasGiveBill);

      const openDialog = (rows) => {
        this.dialogModel1.type = 'add';
        this.dialogModel1.changeType = 'invoice';
        this.dialogModel1.title = this.$t('fms_invoiceManage.kai_piao_shen_qing');
        this.dialogModel1.row = rows;
        this.dialogVisible1 = true;
      };

      if (!hasGiveBillList.length) {
        openDialog(tableSelect);
        return;
      }

      const queryList = tableSelect.length ? tableSelect : [];
      const requestList = [];

      queryList.forEach((item) => {
        if (!item.hasGiveBill) {
          return;
        }
        const params = {
          ...this.formSearch,
          excludeGiveBill: !item.hasGiveBill,
          contractNo: item.contractNo || '',
          bodyNum: item.bodyNum || '',
          deviceNo: item.deviceNo || '',
          termNum: item.termNum || '',
          pageNum: 1,
          pageSize: 9999,
        };
        requestList.push(this.$getJSON(apis.invoiceWaitPage, params));
      });

      if (!requestList.length) {
        openDialog(tableSelect);
        return;
      }

      this.isLoading = true;
      Promise.all(requestList).then((resList) => {
        const mergedRows = [...tableSelect];
        resList.forEach((res) => {
          const records = (res.data && res.data.records) || [];
          records.forEach((record) => {
            const exist = mergedRows.some(item => item.invoiceBillWaitId === record.invoiceBillWaitId);
            if (!exist) {
              mergedRows.push(record);
            }
          });
        });
        mergedRows.sort((a, b) => {
          const bodyA = `${a.bodyNum || ''}`;
          const bodyB = `${b.bodyNum || ''}`;
          if (bodyA !== bodyB) {
            return bodyA.localeCompare(bodyB, 'zh-CN');
          }
          const termA = Number(a.termNum) || 0;
          const termB = Number(b.termNum) || 0;
          return termA - termB;
        });

        this.isLoading = false;
        this.tableSelect = mergedRows;
        openDialog(mergedRows);
      }).catch(() => {
        this.isLoading = false;
      });
    },
    // 导入待开票
    importInvoice: function () {
      this.dialogModel2.type = 'add';
      this.dialogModel2.title = this.$t('fms_invoiceManage.dao_ru_dai_kai_piao');
      this.dialogVisible2 = true;
    },
    // 导入待开票
    onSelectWaitInvoice: function () {
      this.dialogModel5.type = 'add';
      this.dialogModel5.title = this.$t('fms_invoiceManage.xuan_ze_dai_kai_piao');
      this.dialogVisible5 = true;
    },
    // 编辑备注
    onEditRemarkInvoice: function (row) {
      this.dialogModel6.type = 'edit';
      this.dialogModel6.title = this.$t('fms_invoiceManage.bian_ji_bei_zhu');
      this.dialogModel6.data = row;
      this.dialogVisible6 = true;
    },
    // 冲红申请
    onGoRedDialog: function (row) {
      this.dialogModel1.type = 'add';
      this.dialogModel1.changeType = 'red_application';
      this.dialogModel1.row = row;
      this.dialogVisible1 = true;
    },
    // 登记开票
    onRegister: function (row) {
      // isRedInvoice true是冲红
      // isRedInvoice false是蓝票
      this.dialogModel3.type = 'add';
      this.dialogModel3.title = this.$t('fms_invoiceManage.deng_ji_fa_piao');
      this.dialogModel3.row = row;
      this.dialogVisible3 = true;
    },
    onInvoiceDetails: function (invoiceId, isRedInvoice) {
      // isRedInvoice true是冲红
      // isRedInvoice false是蓝票
      if (!invoiceId) {
        return;
      }
      this.dialogModel4.type = isRedInvoice;
      this.dialogModel4.title = this.$t('fms_invoiceManage.fa_piao_xiang_qing');
      this.dialogModel4.invoiceId = invoiceId;
      this.dialogVisible4 = true;
    },
    // 删除待申请开票
    deleteWaitInvoice: function (row) {
      const data = row ? [row.invoiceBillWaitId] : this.tableSelect.map(t => t.invoiceBillWaitId);
      this.$showConfirm(this.$t('fms_invoiceManage.nqdyscgdsqfpm'))
        .then(() => {
          this.$postJSON(apis.invoiceDelete, data).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getTableList();
          });
        })
        .catch(() => {});
    },
    // 导出
    exportInvoiceTable() {
      const param = {};
      Object.keys(this.formSearch).forEach((key) => {
        const val = this.formSearch[key];
        if (val) {
          param[key] = val;
        }
      });
      delete param.pageSize;
      delete param.pageNum;
      const pathParms = qs.stringify(param, { arrayFormat: 'repeat' });
      const headerList = this.tableColumn
        .filter(t => t.isExport)
        .map(i => ({ columnCode: i.columnCode, columnName: i.columnName, width: i.width, isFormat: i.isFormat, formatRule: i.formatRule, dicGroup: i.dicGroup }));
      this.headerListAddInvoiceClass(headerList);
      const reqData = {
        exportName: this.$t('fms_invoiceManage.kai_piao_guan_li'),
        headerList: headerList,
      };
      this.exporting = true;
      this.$exportFliePost(`${this.tab === '0' ? apis.invoiceWaitExport : apis.invoiceListExport}?${pathParms}`, reqData)
        .then(() => {
          this.exporting = false;
        })
        .catch(() => {
          this.exporting = false;
        });
    },
  },
};
</script>

<style lang="scss"></style>
